export enum map {
    ELDERLY_CARE = "ELDERLY_CARE",
    PHARMACY = "PHARMACY",
    BAD = "BAD",
    CGHTestElevator = "whiteboard"
}